import {useDebugValue} from 'react';

import {
    useStoreData,
    useStoreKeys
} from './';

function useStore(config, defaultStore, ...otherStores) {
    const {
        storeDataRef,
        storeKeysRef
    } = config;

    const {
        storeKeys
    } = useStoreKeys({storeKeysRef}, defaultStore, otherStores);

    const {
        storeData
    } = useStoreData({storeDataRef, storeKeys}, defaultStore, otherStores);

    const store = {
        [storeDataRef]: storeData,
        [storeKeysRef]: storeKeys
    };

    const result = {
        store
    };

    useDebugValue(result);

    return result;
}

export {useStore};
